import { lentraRedirect } from "../../utils/userGesture";
import styles from "./ErrerPage.module.scss";

export default function ErrerPage() {

   const handleTryAgain = async () => {
    await lentraRedirect();
  };

  return (
    <div className={styles.not__found}>
      <div className={styles.wrapper}>
        <img
          src="/images/not-found.svg"
          className={styles.image}
          alt="Error"
        />

        <h1>Something went wrong</h1>

        <h3>
          Login was successful. We couldn't load the next step.
          <br />
          Your progress is saved.
          <br />
          Please try again.
        </h3>

        <button
          className={styles.retryBtn}
          onClick={handleTryAgain}
        >
          Try Again
        </button>

        <p
          onClick={() =>
            window.open(
              "https://www.ramfincorp.com/contact-us",
              "_blank",
              "noopener,noreferrer"
            )
          }
          className={styles.supportText}
        >
          Contact Support
        </p>
      </div>
    </div>
  );
}